// ═══════════════════════════════════════════════════════════════════
//  layout/Sidebar.js
//  Sidebar
// ═══════════════════════════════════════════════════════════════════

import { BouxImg } from "../composants/BouxImg";
import { THEME } from "../socle/theme";
import { NAV_ITEMS } from "./navigation";

export function Sidebar({ active, onNavigate, user, onLogout }) {
  return (
    <div style={{ width: 230, background: THEME.surface, borderRight: `1px solid ${THEME.border}`, display: "flex", flexDirection: "column", flexShrink: 0, height: "100vh", position: "sticky", top: 0 }}>
      <div style={{ padding: "20px 20px 16px", borderBottom: `1px solid ${THEME.border}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22, color: THEME.gold }}>✦</span>
          <BouxImg height={34} />
          <div>
            <div style={{ color: THEME.gold, fontWeight: 800, fontSize: 16, letterSpacing: 1 }}>BOXORIA</div>
            <div style={{ color: THEME.textMuted, fontSize: 10 }}>Intranet Staff</div>
          </div>
        </div>
      </div>
      <nav style={{ flex: 1, padding: "12px 10px", display: "flex", flexDirection: "column", gap: 2 }}>
        {NAV_ITEMS.map((item) => (
          <button key={item.id} disabled={!item.ready} onClick={() => item.ready && onNavigate(item.id)}
            style={{
              background: active === item.id ? THEME.accentDim : "transparent",
              border: `1px solid ${active === item.id ? THEME.accent : "transparent"}`,
              color: !item.ready ? THEME.textDim : active === item.id ? THEME.accent : THEME.textMuted,
              borderRadius: 8, padding: "9px 12px", display: "flex", alignItems: "center", gap: 10,
              cursor: item.ready ? "pointer" : "not-allowed", fontSize: 13,
              fontWeight: active === item.id ? 600 : 400, textAlign: "left", width: "100%", opacity: item.ready ? 1 : 0.5,
            }}>
            <span style={{ fontSize: 16 }}>{item.icon}</span>{item.label}
            {!item.ready && <span style={{ marginLeft: "auto", fontSize: 9, color: THEME.textDim }}>bientôt</span>}
          </button>
        ))}
      </nav>
      <div style={{ padding: "14px 16px", borderTop: `1px solid ${THEME.border}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 34, height: 34, background: THEME.accentDim, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 700, color: THEME.accent }}>
            {user.email[0].toUpperCase()}
          </div>
          <div style={{ overflow: "hidden" }}>
            <div style={{ color: THEME.text, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user.email}</div>
            <div style={{ color: THEME.gold, fontSize: 10, fontWeight: 600 }}>{user.role}</div>
          </div>
          <button onClick={onLogout} title="Déconnexion" style={{ marginLeft: "auto", background: "transparent", border: "none", color: THEME.textMuted, cursor: "pointer", fontSize: 16, padding: 4 }}>⏏</button>
        </div>
      </div>
    </div>
  );
}
